// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kjE0I","title":"styles_title__31GKU"};